<template>
  <div v-if="msg" class="alert alert-danger text-light">
    {{ msg }}
  </div>
</template>

<script>
export default {
  name: 'BaseError',

  props: {
    value: [Object, String]
  },

  data: () => ({
    msg: ''
  }),

  methods: {
    getMessage () {
      if (this.$_.isPlainObject(this.value) && this.$_.has(this.value, 'message')) {
        this.msg = this.value.message
      } else if (this.$_.isString(this.value)) {
        this.msg = this.value
      }
    }
  },

  watch: {
    value: {
      deep: true,
      handler () {
        this.getMessage()
      }
    }
  }
}
</script>
